<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para3-s"><a id="page_ix"></a><em>Look out child, it look like something be coming<br/>It be coming the long way around<br/>Coming the long way around</em></p>
<p class="right-para-s">Chris Whitley, “Long Way Around”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?027f12da